export const features = {
  CREATE_PAGE: "CREATE_PAGE",
  EDIT_PAGE: "EDIT_PAGE",
  IMPORT_PAGE: "IMPORT_PAGE",
  PAGE_UPDATE_INFO: "PAGE_UPDATE_INFO",
  PUBLISH_ONE: "PUBLISH_ONE",
  CLONE_PAGE: "CLONE_PAGE",
  DELETE_PAGE: "DELETE_PAGE",
  REVERT_PAGE: "REVERT_PAGE",
  EDIT_INVISIBLE_COMPONENT: "EDIT_INVISIBLE_COMPONENT",

  REVIEW_REQUESTS: "REVIEW_REQUESTS",
  NAVBAR_CONFIG: "NAVBAR_CONFIG",

  //Page Details
  PAGE_COMMON_DETAILS_SECTION: "PAGE_COMMON_DETAILS_SECTION",
  PAGE_LAYOUT_MAP_SECTION: "PAGE_LAYOUT_MAP_SECTION",
  PAGE_COMPONENT_SECTION: "PAGE_COMPONENT_SECTION",

  //Component Instances - CI_*
  CI_CREATE: "CI_CREATE",
  CI_UPDATE_PROPS: "CI_UPDATE_PROPS",
  CI_ADD_DEFAULT_DATA: "CI_ADD_DEFAULT_DATA",
  CI_REVERT: "CI_REVERT",
  CI_HIDE: "CI_HIDE",
  CI_DELETE: "CI_DELETE",
  CI_EDIT_SMARTHTML: "CI_EDIT_SMARTHTML",
  CI_UPDATE_PROPS_FROM_JSON: "CI_UPDATE_PROPS_FROM_JSON",

  //Layout Instances - LI_*
  LI_UPDATE_MAP: "LI_UPDATE_MAP",

  WEBHOOKS: "WEBHOOKS",

  // Pages Global Configs - PGC_*
  PGC_UPDATE: "PGC_UPDATE",
  PGC_PUBLISH: "PGC_PUBLISH",
  PGC_REVERT: "PGC_REVERT",

  // Users: Role Management
  ROLE_ASSIGNMENT: "ROLE_ASSIGNMENT",
  TEAM_ASSIGNMENT: "TEAM_ASSIGNMENT",
  FEATURE_MAPPING: "FEATURE_MAPPING",

  // Entities: Referral Operations
  REFERRAL_DASHBOARD: "REFERRAL_DASHBOARD",
  REFERRAL_SINGLE_OPERATION: "REFERRAL_SINGLE_OPERATION",
  REFERRAL_BULK_OPERATION: "REFERRAL_BULK_OPERATION",

  // Entities: Scholarship Operations
  SCHOLARSHIP_BUDGET_ALLOCATION: "SCHOLARSHIP_BUDGET_ALLOCATION",
  SCHOLARSHIP_COUPON_APPLY: "SCHOLARSHIP_COUPON_APPLY",
  SCHOLARSHIP_COUPON_CREATE: "SCHOLARSHIP_COUPON_CREATE",

  // Entities: Payment Management Operations
  PAYMENT_UNIVERSITY: "PAYMENT_UNIVERSITY",
  PAYMENT_SETTLEMENT: "PAYMENT_SETTLEMENT",
  PAYMENT_MODES: "PAYMENT_MODES",
  PAYMENT_INVOICE: "PAYMENT_INVOICE",
  PAYMENT_LINK: "PAYMENT_LINK",
  // Entities: Applications Management
  APPLICATION_ID_CONFIG: "APPLICATION_ID_CONFIG",
  APPLICATION_DUMP_CONFIG: "APPLICATION_DUMP_CONFIG",
  // Entities: Application Journeys
  CREATE_APPLICATION_JOURNEY: "CREATE_APPLICATION_JOURNEY",
  CLONE_APPLICATION_JOURNEY: "CLONE_APPLICATION_JOURNEY",
  EDIT_APPLICATION_JOURNEY: "EDIT_APPLICATION_JOURNEY",
  PUBLISH_APPLICATION_JOURNEY: "PUBLISH_APPLICATION_JOURNEY",
  // Entities: Email Management
  EMAIL_CONFIG: "EMAIL_CONFIG",
  // Entities: Shortlisting
  SHORTLISTING_CONFIG: "SHORTLISTING_CONFIG",
  UPLOAD_SHORTLISTING_CSV: "UPLOAD_SHORTLISTING_CSV",
  OVERRIDE_APPLICATION: "OVERRIDE_APPLICATION",
  TRANSFER_APPLICATION: "TRANSFER_APPLICATION",
  // Entities: Batch
  BATCH_CREATE: "BATCH_CREATE",
  BATCH_EDIT: "BATCH_EDIT",
  FINANCE_BATCH_APPROVAL: "FINANCE_BATCH_APPROVAL",
  ASSIGN_PROGRAM_BATCH: "ASSIGN_PROGRAM_BATCH",
  // Entities: Program
  BASE_SETUP: "BASE_SETUP",
  //Entities: Refund
  // upGrad umbrella: create + committee + process in one feature.
  REFUND_OPS: "REFUND_OPS",
  // KH splits the same work across four features (spec "Roles and
  // permissions"); FINANCE_REFUND_APPROVAL is shared by both tenants.
  REFUND_CREATE: "REFUND_CREATE",
  REFUND_COMMITTEE: "REFUND_COMMITTEE",
  REFUND_PROCESS: "REFUND_PROCESS",
  REFUND_REPORT: "REFUND_REPORT",
  FINANCE_REFUND_APPROVAL: "FINANCE_REFUND_APPROVAL",

  //Entities: Config Management
  CONFIG_SETUP: "CONFIG_SETUP",

  // Program launcher
  APP_PAGE: "APP_PAGE",
  LAUNCH_PROGRAM: "LAUNCH_PROGRAM",
  CONTENT_PAGE: "CONTENT_PAGE",
  REFERRAL_PAGE: "REFERRAL_PAGE",

  // Typesense
  TYPESENSE_MANAGEMENT: "TYPESENSE_MANAGEMENT",

  // Download
  DOWNLOAD_APP_DUMP: "DOWNLOAD_APP_DUMP",
};
